






















import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'

@Component({
  name: 'SearchForm'
})
export default class extends Vue {
  private formInline = {
    username: '',
    phone: '',
    state: ''
  }

  // 搜索
  onSearch() {
    this.$emit('onsearchsubmit', { ...this.formInline, currentPage: 1 })
  }

  // 重置
  reset() {
    (this.$refs.searchForm as ElForm).resetFields()
    this.$emit('onsearchsubmit', { ...this.formInline, currentPage: 1 })
  }
}
